import type { SigningTranslations } from "../../types/signing";

export const signing: SigningTranslations = {
  sidebar: "Allkirjastamine",
  title: "Allkirjastamine",
  subtitle: "Selle projekti allkirjastatud konteinerid ja allkirjastamise ahelad",
  tabs: { mine: "Minu allkirjad", all: "Kõik allkirjad" },
  search: "Otsi dokumente…",
  bulk: {
    downloadSkipped: "{count} valitud dokumenti jäeti vahele, sest nende failid pole saadaval.",
  },
  filter: {
    label: "Filter",
    status: "Olek",
    signedBy: "Allkirjastaja",
    date: "Kuupäev",
    from: "Alates",
    to: "Kuni",
    clear: "Tühjenda",
    back: "Tagasi",
  },
  columns: {
    document: "Dokument",
    sender: "Saatja",
    created: "Loodud",
    createdTooltip:
      "Millal see Franklinis loodi: allkirjastatud konteineri üleslaadimise aeg või allkirjastamise alustamise aeg. Ei ole faili metaandmetest pärit kuupäev.",
    status: "Olek",
  },
  status: {
    awaitingYou: "Ootab sinu allkirja",
    awaitingOthers: "Ootab teisi",
    finalizing: "Vormistamisel",
    signed: "Allkirjastatud",
    failed: "Ebaõnnestus",
    cancelled: "Tühistatud",
    expired: "Aegunud",
    unknown: "Teadmata",
  },
  chain: {
    signers: "Allkirjastajad",
    empty: "Allkirjastajaid pole veel salvestatud.",
    step: "{position}. samm",
    you: "Sina",
    progress: "{signed} / {total} allkirjastatud",
    inOrder: "Allkirjastamine järjekorras",
    signerStatus: {
      pending: "Ootel",
      signed: "Allkirjastatud",
      rejected: "Keeldus",
      removed: "Eemaldatud",
    },
  },
  method: {
    smartId: "Smart-ID",
    mobileId: "Mobiil-ID",
    idCard: "ID-kaart",
    unknown: "Teadmata meetod",
  },
  panel: {
    failedTitle: "Allkirjastamine jäi pooleli",
    failedDetail: "Allkirjastamisteenuse teade:",
    eyebrow: "Allkirja üksikasjad",
    signatures: "Allkirjad",
    containerContents: "Konteineri sisu",
    documentsToSign: "Selle seansi dokumendid",
    contentsLoadFailed: "Failide loendit ei õnnestunud laadida. Palun proovi uuesti.",
    noFiles: "Faile pole salvestatud.",
    signedOn: "Allkirjastatud",
    startedOn: "Alustatud",
    download: "Laadi alla",
    downloadFailed: "Allalaadimist ei õnnestunud ette valmistada. Palun proovi uuesti.",
    checkStatus: "Kontrolli olekut",
    expiresOn: "Aegub {date}",
    waitingForOthers:
      "Ootame ülalolevaid allkirjastajaid. Saadame sulle e-kirja, kui on sinu kord.",
    finalizing: "Kõik allkirjad on olemas. Vormistame allkirjastatud ümbrikku — see võtab hetke.",
    finalizingAfterDecline:
      "Üks allkirjastaja keeldus, seega rohkem allkirjastajaid ei ole. Kontrollime allkirjastamisteenusest, kuhu see allkirjastamine jäi.",
    signNow: "Allkirjasta kohe",
    signTurnTitle: "Allkirjasta dokumendid",
    signTurnHint: "Vali Smart-ID, Mobiil-ID või ID-kaart ja allkirjasta allpool.",
    signTurnDone: "Sinu allkiri on salvestatud. Dokument liigub järgmisele allkirjastajale.",
    signTurnCompleted: "Allkirjastatud. Allkirjastatud ümbrik on dokumentide juurde salvestatud.",
    signTurnSealing:
      "Sinu allkiri on salvestatud. Allkirjastatud ümbrikut alles vormistatakse — see ilmub dokumentide juurde, kui on valmis. Võid selle akna sulgeda.",
    signTurnSealingAfterDecline:
      "Sinu allkiri on salvestatud. Üks allkirjastaja keeldus, seega rohkem allkirjastajaid ei ole. Allkirjastamise tulemus ilmub allkirjastamise lehele — võid selle akna sulgeda.",
    signTurnClosedAfterSigning:
      "Sinu allkiri on salvestatud. See allkirjastamine on vahepeal suletud — see tühistati või aegus —, seega allkirjastatud ümbrikut ei salvestata.",
    signTurnFailed: "Allkirjastamist ei õnnestunud avada.",
    signTurnSignFailed:
      "Allkirjastamine ei õnnestunud. Proovi allpool uuesti või sulge see aken ja ava uuesti.",
    cancelSigning: "Tühista allkirjastamine",
    cancelConfirmTitle: "Kas tühistada see allkirjastamine?",
    cancelConfirmBody:
      "Kõik ootel allkirjastajad kaotavad ligipääsu ja konteinerit ei looda. Juba antud allkirju ei saa uuesti kasutada.",
    cancelConfirmAction: "Tühista allkirjastamine",
    cancelKeep: "Jäta avatuks",
    cancelled: "Allkirjastamine tühistatud.",
    signerUnknown: "Allkirjastaja nime ei salvestatud",
  },
  refusal: {
    unknownLink: "See allkirjastamine ei ole sulle enam saadaval.",
    chainClosed: "See allkirjastamine on suletud — see lõpetati, tühistati või aegus.",
    alreadySigned: "Sa oled selle juba allkirjastanud.",
    notYourTurn: "Sinu kord ei ole veel käes. Saadame sulle e-kirja, kui on.",
    noLongerAMember: "Sa ei kuulu enam organisatsiooni, kes selle allkirjastamise alustas.",
    chainDiffers: "Nende dokumentide jaoks on juba pooleli teine allkirjastamine.",
    finalizing: "Seda allkirjastamist vormistatakse — seda ei saa enam tühistada.",
    fullySigned: "Kõik on juba allkirjastanud — seda allkirjastamist ei saa enam tühistada.",
    notAllowed: "Sul ei ole selleks õigust.",
    alreadyInProgress:
      "Nende dokumentide allkirjastamine on juba pooleli. Värskenda lehte ja proovi uuesti.",
    requestRejected:
      "See allkirjastamise päring lükati tagasi. Kontrolli andmeid ja proovi uuesti.",
  },
  selection: {
    selectAll: "Vali kõik allkirjastatud konteinerid",
    selectRow: "Vali {title}",
  },
  unfiled: {
    badge: "Projektita",
    hint: "See allkirjastamine ei ole ühegi projekti alla salvestatud, seetõttu kuvatakse seda selle hoone kõigis projektides.",
  },
  empty: {
    all: {
      title: "Midagi pole veel allkirjastatud",
      subtitle:
        "Allkirjastatud konteinerid ilmuvad siia, kui selle projekti dokumendid on allkirjastatud.",
    },
    mine: {
      title: "Siin pole veel midagi sinu oma",
      subtitle:
        "Siia ilmuvad allkirjastamised, mille sa alustasid, ja need, mida sul paluti allkirjastada.",
    },
    filtered: {
      title: "Vasteid ei leitud",
      subtitle: "Ükski allkiri ei vasta praegusele otsingule ega filtritele.",
    },
  },
  loadFailed: "Allkirju ei õnnestunud laadida.",
  truncated: "Kuvatakse ainult {count} viimast kirjet.",
  signatureCount: { one: "{count} allkiri", many: "{count} allkirja" },
  dialog: {
    title: "Allkirjasta dokumendid",
    containerName: "Allkirjastatud faili nimi",
    output: {
      label: "Väljundvorming",
      asice: "ASiC-E konteiner (.asice)",
      pdf: "Allkirjastatud PDF / PAdES (.pdf)",
      asiceHint: "Ühenda üks või mitu faili allkirjastatud konteinerisse.",
      pdfHint: "Säilita dokument PDF-ina koos manustatud digiallkirjadega.",
      singlePdfRequired:
        "PAdES nõuab täpselt ühte PDF-faili. Mitme faili või muude failitüüpide jaoks kasuta ASiC-E vormingut.",
    },
    documents: "Dokumendid",
    total: "Kokku",
    sign: "Allkirjasta",
    send: "Saada allkirjastamisele",
    cancel: "Tühista",
    close: "Sulge",
    starting: "Valmistan dokumente ette…",
    signingHint: "Vali Smart-ID, Mobiil-ID või ID-kaart ja allkirjasta allpool.",
    resumedHint: "Jätkame allkirjastamist, mille sa nende dokumentidega juba alustasid.",
    completedMsg: "Allkirjastatud fail on lisatud sinu dokumentidesse.",
    errorTitle: "Allkirjastamine ebaõnnestus",
    tryAgain: "Proovi uuesti",
    creatorUnknown:
      "Kaotasime ühenduse sinu kontoga, seega ei saa seda teistele allkirjastajatele saata. Laadi leht uuesti ja proovi uuesti.",
    target: {
      mixedTitle: "Need dokumendid on eri projektides",
      mixedMessage:
        "Üks allkirjastamine kuulub ühte projekti, seega neid koos allkirjastada ei saa. Vali ühe projekti dokumendid ja alusta uuesti.",
      failedTitle: "Allkirjastamist ei õnnestunud ette valmistada",
      failedMessage:
        "Ei õnnestunud tuvastada, millisesse projekti need dokumendid on salvestatud. Palun proovi uuesti.",
    },
    signers: {
      modeLabel: "Allkirjastamise viis",
      selfTitle: "Allkirjastan ise",
      selfDescription: "Allkirjasta kohe ID-kaardi, Mobiil-ID või Smart-ID-ga.",
      sendTitle: "Saada teistele",
      sendDescription: "Kutsu teised allkirjastama; sina allkirjastad esimesena.",
      order: "Allkirjastamise järjekord",
      you: "Sina",
      addOthers: "Saada teistele allkirjastamiseks…",
      youSignFirst: "Sina allkirjastad esimesena, seejärel liigub see allolevatele järjekorras.",
      label: "Allkirjastajad",
      hint: "Jäta tühjaks, et allkirjastada dokumendid ise kohe. Lisa inimesi, et saata see ringi — nad allkirjastavad sammhaaval allpool olevas järjekorras.",
      placeholder: "Lisa allkirjastajaid…",
      search: "Otsi liikmeid…",
      none: "Projekti liikmeid ei leitud.",
      loading: "Laadin liikmeid…",
      needProject:
        "Teiste allkirjastajate kutsumiseks ava projekt. Ilma selleta saad dokumendid ainult ise allkirjastada.",
      max: "Sina allkirjastad esimesena, seega saad lisada kuni {count} teist allkirjastajat.",
      parallel: "Allkirjastavad suvalises järjekorras",
      moveUp: "Liiguta see samm ettepoole",
      moveDown: "Liiguta see samm tahapoole",
      mergeUp: "Allkirjasta koos ülaloleva sammuga",
      split: "Anna sellele allkirjastajale oma samm",
      remove: "Eemalda see allkirjastaja",
      youSignAt: "Sina allkirjastad {position}. sammul.",
      youDoNotSign: "Sina ei ole allkirjastaja — saadad selle teistele allkirjastamiseks.",
    },
    invited: {
      title: "Kutsed saadetud",
      message: "Kutsutud on {count} allkirjastajat. Igaüks saab e-kirja, kui tema kord käes on.",
      firstUp: "Esimesena: {names}",
    },
    handedOn: {
      title: "Sinu allkiri on salvestatud",
      message:
        "Allkirjastada on jäänud veel {count}. Igaüks saab e-kirja, kui tema kord käes on, ja sina saad e-kirja, kui allkirjastatud ümbrik on valmis.",
      finalizing: "Kõik on allkirjastanud. Allkirjastatud ümbrikut valmistatakse ette.",
    },
    cancelOther: "Tühista teine allkirjastamine ja jätka",
    cancelling: "Tühistan…",
  },
};
